export const BASEURL = "https://api.stealthnet.ai"//"http://127.0.0.1:8089"//"https://api1-service-dot-gen-lang-client-0165304536.ue.r.appspot.com" 
export var PRIMARYCOLOR = "#005CC5"//"#3e2969"//"#ac2024"//"#005CC5" #06a1b6
export var SECONDARYCOLOR = "#000"//"#E3F2FD"
export var logoURL = "https://www.stealthnet.ai/logo512.png"
export var COMPANY = "StealthNet AI"